import { Injectable } from '@angular/core';
import { Observable, from as observableFrom } from 'rxjs';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { rentalObjectCommand } from '../../command/rental-object.command';

@Injectable()
export class AdvertiseRentalObjectCommandHandler implements ICommandHandler {
  constructor(private _navigationService: NavigationService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === rentalObjectCommand.advertise && command.context;
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof Command) {
      let id = command.context.rentalObjectId ? command.context.rentalObjectId : command.context.id;
      return observableFrom(this._navigationService.navigateChild([id, 'advertisments', 'add']));
    }
  }
}
